import { render, staticRenderFns } from "./previsuacion-archivos.vue?vue&type=template&id=6dbb6317&scoped=true&"
import script from "./previsuacion-archivos.vue?vue&type=script&lang=ts&"
export * from "./previsuacion-archivos.vue?vue&type=script&lang=ts&"
import style0 from "./previsuacion-archivos.vue?vue&type=style&index=0&id=6dbb6317&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbb6317",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VRow,VTooltip})
